import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gm63vb47za: FaireBrandEntity = {
  token: "b_gm63vb47za",
  type: "brand",
  name: "Little Organic Co",
  avatarUrl:
    "https://cdn.faire.com/fastly/7adeaf330b2e9dd580ad1eb5e772e4885e21f582a56f0c374ec0dfff485f4891.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/8f8aa39c0bb04d0d256bb6712550ca2c922693ffb05eca3acbfbe036d26a581b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/7adeaf330b2e9dd580ad1eb5e772e4885e21f582a56f0c374ec0dfff485f4891.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8f8aa39c0bb04d0d256bb6712550ca2c922693ffb05eca3acbfbe036d26a581b.png",
  location: "Greeley, CO, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 76,
  isInsider: true,
  description:
    "Our organic clothing is made with love and care for your little ones. We believe that natural fabrics are not only better for the environment, but also better for your baby's delicate skin. Our clothes are soft, breathable, and free from harmful chemicals. Make a difference in your baby's life with our organic clothing line.\nAs parents ourselves, we know how important it is to give your baby the best start in life. That's why we started our company, to provide parents with high-quality, organic clothing that is not only stylish but also gentle on their baby's skin. Our fabrics are sourced from certified organic cotton farmers, and our dyes and prints are all-natural and safe for your little one. We believe that every baby deserves to be wrapped in love and comfort, and our clothes are designed with just that in mind. Join us in our mission to create a healthier and happier world for our babies, one organic clothing piece at a time",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:58.864Z",
    importedBy: "entity-db-cli",
  },
};
